import React from 'react';
import { createRoot } from 'react-dom/client';
import $ from 'jquery';
import cleanObj from 'utils/cleanObj';
import TabListing from './index';

// Script to initialise Tab Listing React component on all .listing-app elements
$('.result-app').each(function () {
    const appID = $(this).data('app-id');
    const $apiDataDiv = $(`.${appID}-api-json`);

    // Early return if div target is not specified
    if (!appID || !$apiDataDiv.length) { return; }

    // Setup props
    const props = {
        url: $apiDataDiv.data('api-url'),
        data: $apiDataDiv.html(),
        noResultText: $apiDataDiv.data('no-result-text'),
        listingAppID: appID,
        tileType: $apiDataDiv.data('tile-type'),
        tileContainerColumnClass: $apiDataDiv.data('tile-container-column-class'),
        tileContainerTilesWrap: $apiDataDiv.data('tile-container-tile-wrap'),
        tabsLayout: $apiDataDiv.data('tabs-layout')
    };

    // Remove any empty prop settings to let the default prop values kick in
    cleanObj(props);

    const root = createRoot($(this)[0]);
    root.render(
        React.createElement(TabListing, props, null)
    );
});
